// extracted by mini-css-extract-plugin
export default {"wave":"wave__Vbfb8E","waveLine":"waveLine__ROWZHx"};